import React from "react";
import {
  TextField,
  createMuiTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Grid,
} from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import { Autocomplete } from "@material-ui/lab";

export default function EditBacktestingConfigPageInfo(props) {
    const { 
        backtestingConfig, setBacktestingConfig, allCoins, 
        handleChange, handleFormChange, readonly, separatedCoins
    } = props;

    return (
        <>
            <TextField
            id={`fullName`}
            label="Full Name"
            value={backtestingConfig.fullName}
            onChange={handleChange("fullName")}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{readOnly: readonly }}
            margin="normal"
            variant="outlined"
            required
            fullWidth
            />

            <TextField
            id={`days`}
            label="Days"
            value={backtestingConfig.days}
            onChange={handleChange("days")}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{readOnly: readonly }}
            type="number"
            margin="normal"
            variant="outlined"
            required
            fullWidth
            />

            <TextField
            id={`interval`}
            label="Candle interval (min)"
            value={backtestingConfig.interval}
            onChange={handleChange("interval")}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{readOnly: readonly }}
            type="number"
            margin="normal"
            variant="outlined"
            required
            fullWidth
            />
            
            <TextField
            id={`emaPeriod`}
            label="Ema period"
            value={backtestingConfig.emaPeriod}
            onChange={handleChange("emaPeriod")}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{readOnly: readonly }}
            type="number"
            margin="normal"
            variant="outlined"
            required
            fullWidth
            />
            
            <TextField
            id={`filterTop`}
            label="Filter top"
            value={backtestingConfig.filterTop}
            onChange={handleChange("filterTop")}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{readOnly: readonly }}
            type="number"
            margin="normal"
            variant="outlined"
            required
            fullWidth
            />
            
            <TextField
            id={`filterBottom`}
            label="Filter bottom"
            value={backtestingConfig.filterBottom}
            onChange={handleChange("filterBottom")}
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{readOnly: readonly }}
            type="number"
            margin="normal"
            variant="outlined"
            required
            fullWidth
            />

            <Row>
            <Col>
                <TextField
                id={`tp1`}
                label="Take profit 1"
                value={backtestingConfig.tp1}
                onChange={handleChange("tp1")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            <Col>
                <TextField
                id={`tp2`}
                label="Take profit 2"
                value={backtestingConfig.tp2}
                onChange={handleChange("tp2")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            </Row>
            
            <Row>
            <Col>
                <TextField
                id={`sl1`}
                label="Stop loss 1"
                value={backtestingConfig.sl1}
                onChange={handleChange("sl1")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            <Col>
                <TextField
                id={`sl2`}
                label="Stop loss 2"
                value={backtestingConfig.sl2}
                onChange={handleChange("sl2")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            </Row>
            
            <Grid item xs={12} sm={6}>
                <FormControlLabel
                control={
                    <Checkbox
                    checked={backtestingConfig.longs}
                    onChange={(e) =>
                        setBacktestingConfig({
                        ...backtestingConfig,
                        longs: e.target.checked,
                        })
                    }
                    name="longs"
                    color="primary"
                    />
                }
                label="Longs Activados"
                />
            <FormControlLabel
                control={
                <Checkbox
                    checked={backtestingConfig.shorts}
                    onChange={(e) =>
                    setBacktestingConfig({
                        ...backtestingConfig,
                        shorts: e.target.checked,
                    })
                    }
                    name="shorts"
                    color="primary"
                />
                }
                label="Shorts Activados"
            />

            </Grid>
            
            <Row>
            <Col>
                <TextField
                id={`accountAmount`}
                label="Account amount"
                value={backtestingConfig.accountAmount}
                onChange={handleChange("accountAmount")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            <Col>
                <TextField
                id={`percentagePerTrade`}
                label="Percentage per trade"
                value={backtestingConfig.percentagePerTrade}
                onChange={handleChange("percentagePerTrade")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            </Row>

            <Row>
            <Col>
                <TextField
                id={`percentageComission`}
                label="Comission percentage"
                value={backtestingConfig.percentageComission}
                onChange={handleChange("percentageComission")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col>
            {/* <Col>
                <TextField
                id={`risk`}
                label="Risk"
                value={backtestingConfig.risk}
                onChange={handleChange("risk")}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="number"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </Col> */}
            </Row>


            {!readonly ? (
            <>
                <FormControl
                variant="outlined"
                fullWidth
                margin="normal"
                required
                >
                <InputLabel id="candle-source-label">
                    Candle Source
                </InputLabel>
                <Select
                    labelId="candle-source-label"
                    value={backtestingConfig?.source}
                    onChange={(e) =>
                    handleFormChange("source", e.target.value)
                    }
                    label="Candle Source"
                >
                    <MenuItem value="">
                    <em>None</em>
                    </MenuItem>
                    <MenuItem value="close">Close</MenuItem>
                    <MenuItem value="open">Open</MenuItem>
                    <MenuItem value="high">High</MenuItem>
                    <MenuItem value="low">Low</MenuItem>
                    <MenuItem value="ohlc4">Ohlc4</MenuItem>
                </Select>
                </FormControl>

                <Autocomplete
                multiple
                options={allCoins || []}
                getOptionLabel={(option) => option}
                value={backtestingConfig?.symbols || []}
                onChange={(event, newValue) => {
                    setBacktestingConfig((prev) => ({
                    ...prev,
                    symbols: newValue,
                    }));
                }}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    variant="outlined"
                    label="Select Coins"
                    placeholder="Coins"
                    />
                )}
                />

                <Grid item xs={12} sm={6}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={
                        backtestingConfig?.symbols?.length === separatedCoins?.usdt?.length &&
                        allCoins?.length > 0
                        }
                        onChange={() => {
                        setBacktestingConfig({...backtestingConfig, symbols: separatedCoins.usdt})
                        }}
                        name="selectAllCoinsUSDT"
                        color="primary"
                    />
                    }
                    label="Select All Coins USDT"
                />
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={
                        backtestingConfig?.symbols?.length === separatedCoins?.usdc?.length &&
                        allCoins?.length > 0
                        }
                        onChange={() => {
                        setBacktestingConfig({...backtestingConfig, symbols: separatedCoins.usdc})
                        }}
                        name="selectAllCoinsUSDC"
                        color="primary"
                    />
                    }
                    label="Select All Coins USDC"
                />
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={backtestingConfig?.symbols?.length === 0}
                        onChange={() => {
                        setBacktestingConfig({...backtestingConfig, symbols: []})
                        }}
                        name="selectAllCoins"
                        color="primary"
                    />
                    }
                    label="Quit All Coins"
                />
                </Grid>
                <br />< br />
            </>
            ) : (
            <>
                <TextField
                id={`source`}
                label="Candle source"
                value={backtestingConfig.source}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="text"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />

                <TextField
                id={`symbols`}
                label="Coins"
                value={backtestingConfig.symbols}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{readOnly: readonly }}
                type="text"
                margin="normal"
                variant="outlined"
                required
                fullWidth
                />
            </>
            )}
        </>
    );
}
